import { CssBaseline, GlobalStyles, StyledEngineProvider, ThemeProvider } from '@mui/material';
import React, { FC, ReactNode } from 'react';
import { createBaseTheme } from '../../themes/base.theme';
import { getGlobalStyles } from '../../utils/global-styles.util';
import { useTheme } from '../../hooks/theme.hook';

type Props = {
    children?: ReactNode;
};

export const CarityTheme: FC<Props> = ({ children }) => {
    const theme = window.carity.environment.theme;
    const { palette } = useTheme();

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={createBaseTheme(theme)}>
                <CssBaseline />
                <GlobalStyles styles={getGlobalStyles(palette)} />
                {children}
            </ThemeProvider>
        </StyledEngineProvider>
    );
};
